import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';
import { IngredientForm } from '@/features/ingredients/IngredientForm';

/**
 * /ingredients/new, with an optional ?name= to start from: the list's "No
 * ingredients match" passes what the chef typed in its filter, so Add
 * ingredient keeps it. The router JSON-parses a numeric value ("?name=40"),
 * hence String().
 */
export const Route = createFileRoute('/_app/ingredients/new')({
  validateSearch: (s: { name?: string | number } & SearchSchemaInput): { name?: string } => ({
    name: s.name === undefined || s.name === null || String(s.name).trim() === '' ? undefined : String(s.name).slice(0, 200),
  }),
  component: NewIngredient,
});

function NewIngredient() {
  const { name } = Route.useSearch();
  return <IngredientForm mode="create" initialName={name} />;
}
